import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { EquipamentoService } from '@core/services/domain-services';

export type EquipmentTypeKey = 'armas' | 'viaturas' | 'utensilios';

export const EQUIPMENT_TYPE_IDS: Record<EquipmentTypeKey, number> = {
  armas: 1,
  viaturas: 2,
  utensilios: 3,
};

@Injectable({ providedIn: 'root' })
export class EquipmentCountsService {
  private readonly equipamentoService = inject(EquipamentoService);
  private readonly cache = new Map<number, Observable<number>>();

  getTotal(type: EquipmentTypeKey): Observable<number> {
    const typeId = EQUIPMENT_TYPE_IDS[type];
    const cached = this.cache.get(typeId);
    if (cached) return cached;

    const request$ = this.equipamentoService
      .getAll({
        IdTipoEquipamento: typeId,
        pageNumber: 1,
        pageSize: 1,
      })
      .pipe(
        map((response) => response.totalRecords ?? 0),
        catchError(() => of(0)),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    this.cache.set(typeId, request$);
    return request$;
  }

  setTotal(type: EquipmentTypeKey, total: number): void {
    this.cache.set(EQUIPMENT_TYPE_IDS[type], of(total));
  }

  invalidate(type: EquipmentTypeKey): void {
    this.cache.delete(EQUIPMENT_TYPE_IDS[type]);
  }
}
